import { SetStateAction, useState } from 'react';
import CitiesSorting from './CitySorting';
import ReviewsSorting from './ReviewsSorting';
import styled from 'styled-components';
import AddReview from './AddReview';
interface IProps {
  cityFilter: Record<string, any>;
  setCityFilter: React.Dispatch<React.SetStateAction<
    Record<string, any>
  > | null>;
  sortOrder: string;
  setSortOrder: React.Dispatch<React.SetStateAction<string>>;
  citiesPageDropDown: Record<string, any>[] | undefined;
  citiesDropDown: Record<string, any>;
  citiesToggle: boolean;
  setCitiesToggle: React.Dispatch<SetStateAction<boolean>>;
  sortToggle: boolean;
  setSortToggle: React.Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
  setRefetch: React.Dispatch<SetStateAction<boolean>>;
}
export interface MyErrorObject {
  product?: string;
  cities?: string;
  date?: string;
}
interface StyleProps {
  isRated: number;
}
const ReviewsFilterNav = ({
  cityFilter,
  setCityFilter,
  sortOrder,
  setSortOrder,
  citiesPageDropDown,
  citiesToggle,
  setCitiesToggle,
  sortToggle,
  citiesDropDown,
  setSortToggle,
  currentPage,
  setCurrentPage,
  setRefetch
}: IProps) => {
  const [city, setCity] = useState<string | undefined>();
  const [dispModal, setDispModal] = useState<boolean>(false);
  const [errorObject, setErrorObject] = useState<MyErrorObject>({});
  const ReviewBtnStyle = styled.p<StyleProps>`
    background-color: ${props => (props.isRated > 0 ? '#2E3D7A' : '#1F2C5B')};
    color: ${props => (props.isRated > 0 ? 'white' : 'white')};
  `;
  const [rating, setRating] = useState<number>(0);
  const handleRating = (rate: number) => {
    setRating(rate);
  };
  return (
    <section id="reviews filter" className="mt-5">
      <div className="flex flex-col md:flex-row w-[288px] xsm:w-[340px] md:w-[700px] xl:w-[1000px] 2xl:w-[1332px]   rounded-lg  bg-[#F7F8FB] mx-auto justify-start gap-4 px-2 md:px-4 py-4 md:py-6">
        <div className="order-1 flex gap-1 md:gap-4">
          <CitiesSorting
            cityFilter={cityFilter}
            setCityFilter={setCityFilter}
            citiesDropdown={citiesPageDropDown}
            city={city}
            setCity={setCity}
            citiesToggle={citiesToggle}
            setCitiesToggle={setCitiesToggle}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          <ReviewsSorting
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            sortToggle={sortToggle}
            setSortToggle={setSortToggle}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>

        <div className="w-fill ml-auto h-[44px] md:h-[42px] order-0 md:order-6">
          <ReviewBtnStyle
            isRated={rating}
            className=" text-[18px] text-white font-[400] border border-primary rounded-[48px] px-4 py-[0.4rem] hover:cursor-pointer hover:bg-[#2E3D7A] hover:text-white"
            onClick={() => setDispModal(!dispModal)}
          >
            Write a Review
          </ReviewBtnStyle>
        </div>
      </div>

      {dispModal && (
        <AddReview
          dispModal={dispModal}
          setDispModal={setDispModal}
          citiesPageDropDown={citiesPageDropDown}
          handleRating={handleRating}
          rating={rating}
          setRating={setRating}
          citiesDropDown={citiesDropDown}
          errorObject={errorObject}
          setErrorObject={setErrorObject}
          setRefetch={setRefetch}
        />
      )}
    </section>
  );
};

export default ReviewsFilterNav;
